import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import {Dimmer} from "../components/spinner";
import { formatMoneda } from '../util/varios.js';

const CatalogoFondoAvanceAprob = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'DESCRIPCION', textAlign: 'center' },
        { label: 'MONTO', textAlign: 'center' },
        { label: 'RESPONSABLE', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idfondo.includes(target.value)
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.monto.toString().replace('.', ','), ',', '.', 2).includes(target.value)
                            || x.responsable.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarFondos = () => {

        let campos = "*";
        let nomtab = 'fondoavance';
        let condi = props.condicion;
        let orden = 'idfondo';
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    
        setActivate(true);
    
        axios.get(endpoint,{
            headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }
          }).then(function (response) {
    
          if (response.status === 200) {

            setActivate(false);
            var data = []
            for (let i = 0; i < response.data.length; i++) {
                data.push({
                    idfondo: response.data[i].idfondo,
                    descripcion: response.data[i].descripcion,
                    monto: response.data[i].monto,
                    responsable: response.data[i].responsable,
                    tipofondo: response.data[i].tipofondo
                })
            }
            setRecords(data)   
          }  

    
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    
      }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectFondo = () => {

        var idfondo = values[0].idfondo;
        var descripcion = values[0].descripcion;
        var monto = values[0].monto;
        var responsable = values[0].responsable;
        var tipofondo = values[0].tipofondo;

        blanquear();
        props.onHideAceptaFondos(idfondo, descripcion, monto, responsable, tipofondo);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var idfondo = recordsAfterPagingAndSorting()[index].idfondo;
        var descripcion = recordsAfterPagingAndSorting()[index].descripcion;
        var monto = recordsAfterPagingAndSorting()[index].monto;
        var responsable = recordsAfterPagingAndSorting()[index].responsable;
        var tipofondo = recordsAfterPagingAndSorting()[index].tipofondo;

        var datos = [];
        datos.push({
            idfondo,
            descripcion,
            monto,
            responsable,
            tipofondo
        })
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarFondos()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>{'Seleccionar Fondos'}</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.idfondo}</td>
                                        <td className='py-2 text-start' style={{ width: '250px' }}>{item.descripcion}</td>
                                        <td className='py-2 text-right' style={{ width: '100px' }}>{formatMoneda(item.monto.toString().replace('.', ','), ',', '.', 2)}</td>
                                        <td className='py-2 text-center' style={{ width: '150px' }}>{item.responsable}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectFondo}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoFondoAvanceAprob;